import { useSession } from "next-auth/react"
import React, { PropsWithChildren } from "react"

export const LoggedInOnly: React.FC<PropsWithChildren<unknown>> = ({ children }) => {
  const { status } = useSession()
  return status !== "authenticated" ? null : <>{children}</>
}
